import Cursor, { CursorTypes } from 'editor/components/Cursor';
import Markup from 'editor/components/Markup';
import SheetEvents from 'editor/components/SheetEvents';
import noop from 'lodash/noop';
import { MouseMoveArgs, MouseUpArgs } from './index';

function mouseMove(args: MouseMoveArgs): void {
  const { world } = args;

  world.grabAll(Cursor).forEach(({ component }) => {
    component.cursor = CursorTypes.Default;
  });
}

function mouseUp(args: MouseUpArgs): void {
  const { hit, markupKit, world } = args;
  const { MKMarkup } = markupKit;

  const radius = 10;
  const markupComp = new Markup();
  const m = MKMarkup.createCircle();

  const creationDate = new Date().toISOString();
  m.setCreationDate(creationDate);
  m.setModDate(creationDate);

  m.setWidth(5);
  m.setFillColor(0.8901961, 0.16078432, 0.25882354);
  m.setStrokeColor(0.8901961, 0.16078432, 0.25882354);
  m.setRectDiff(0.5, 0.5, 0.5, 0.5);
  m.setRect(hit.x - radius, hit.y - radius, hit.x + radius, hit.y + radius);

  markupComp.mkMarkup = m;
  markupComp.isPunch = true;

  world.grabAll(SheetEvents).forEach(({ component }) => {
    component.emit('create:punch', { markupComp });
  });
}

export default {
  mouseDown: noop,
  mouseMove,
  mouseUp,
  click: noop,
  dblclick: noop,
};
